<template>
    <div class="hello">
        <section v-if="errored">
            <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
        </section>


        <div id='resulttarget' class="retailerResults clearfix">
            <div class="resultsblock">

                <form  action="" method="get"
                      @submit.prevent="get_retailers_by_keyword()">
                <div class="filters row cf">

                    <div class="dropdowns clearfix">
                        <div class="filterexpl">Filter results by:</div>
                        <div class="row">

                            <div class="m-all medium-4 large-3 columns">
                                    <select v-model="alphaselect" name="alpha" class="alphadropdown"
                                            v-on:change="page = 1; get_retailers_by_alpha()">
                                    <option value="">Filter by Name</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                    <option value="E">E</option>
                                    <option value="F">F</option>
                                    <option value="G">G</option>
                                    <option value="H">H</option>
                                    <option value="I">I</option>
                                    <option value="J">J</option>
                                    <option value="K">K</option>
                                    <option value="L">L</option>
                                    <option value="M">M</option>
                                    <option value="N">N</option>
                                    <option value="O">O</option>
                                    <option value="P">P</option>
                                    <option value="Q">Q</option>
                                    <option value="R">R</option>
                                    <option value="S">S</option>
                                    <option value="T">T</option>
                                    <option value="U">U</option>
                                    <option value="V">V</option>
                                    <option value="W">W</option>
                                    <option value="X">X</option>
                                    <option value="Y">Y</option>
                                    <option value="Z">Z</option>
                                </select>
                            </div>
                            <div class="m-all medium-4 large-3 columns">
                                    <select v-model="stateselect" name="stateselect" class="alphadropdown"
                                            v-on:change="page = 1; get_retailers_by_state()">
                                    <option value="">Filter by Location</option>
                                    <option value="closest">Find locations closest to me</option>
                                    <option value="AB">AB</option>
                                    <option value="AK">AK</option>
                                    <option value="AL">AL</option>
                                    <option value="AR">AR</option>
                                    <option value="AZ">AZ</option>
                                    <option value="BC">BC</option>
                                    <option value="CA">CA</option>
                                    <option value="CO">CO</option>
                                    <option value="CT">CT</option>
                                    <option value="DC">DC</option>
                                    <option value="DE">DE</option>
                                    <option value="FL">FL</option>
                                    <option value="GA">GA</option>
                                    <option value="HI">HI</option>
                                    <option value="IA">IA</option>
                                    <option value="ID">ID</option>
                                    <option value="IL">IL</option>
                                    <option value="IN">IN</option>
                                    <option value="KA">KA</option>
                                    <option value="KS">KS</option>
                                    <option value="KY">KY</option>
                                    <option value="LA">LA</option>
                                    <option value="MA">MA</option>
                                    <option value="MB">MB</option>
                                    <option value="MD">MD</option>
                                    <option value="ME">ME</option>
                                    <option value="MI">MI</option>
                                    <option value="MN">MN</option>
                                    <option value="MO">MO</option>
                                    <option value="MS">MS</option>
                                    <option value="MT">MT</option>
                                    <option value="NB">NB</option>
                                    <option value="NC">NC</option>
                                    <option value="ND">ND</option>
                                    <option value="NE">NE</option>
                                    <option value="NH">NH</option>
                                    <option value="NJ">NJ</option>
                                    <option value="NM">NM</option>
                                    <option value="NS">NS</option>
                                    <option value="NV">NV</option>
                                    <option value="NW">NW</option>
                                    <option value="NY">NY</option>
                                    <option value="OH">OH</option>
                                    <option value="OK">OK</option>
                                    <option value="ON">ON</option>
                                    <option value="OR">OR</option>
                                    <option value="PA">PA</option>
                                    <option value="PE">PE</option>
                                    <option value="PR">PR</option>
                                    <option value="QC">QC</option>
                                    <option value="RI">RI</option>
                                    <option value="SC">SC</option>
                                    <option value="SD">SD</option>
                                    <option value="SK">SK</option>
                                    <option value="T">T</option>
                                    <option value="TN">TN</option>
                                    <option value="TX">TX</option>
                                    <option value="UT">UT</option>
                                    <option value="VA">VA</option>
                                    <option value="VI">VI</option>
                                    <option value="VT">VT</option>
                                    <option value="WA">WA</option>
                                    <option value="WI">WI</option>
                                    <option value="WV">WV</option>
                                    <option value="WY">WY</option>
                                </select>
                            </div>

                            <div class="m-all medium-4 large-3 columns">
                                    <select v-model="typeselect" name="typeselect" class="alphadropdown"
                                            v-on:change="page = 1; get_retailers_by_type()">
                                    <option value="">Filter by Support Level</option>
                                    <option value="supporting">2018 Supporting Retailer</option>
                                </select>

                            </div>

                            <div class="keywordretailer search large-3 columns">

                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
                                       type="text" class="keyword" name="keywordretailer"
                                       placeholder="Retailer Name, Keyword, Zip Code" value="" v-model="keyword">
                                <i class="fa fa-search" v-on:click="get_retailers_by_keyword()"></i>

                            </div>

                        </div>
                    </div>
                </div>
                </form>

                <div class="pager row" v-if="(meta != null)">
                    <span class="pagerdetails medium-12 large-4 columns">&nbsp;{{ showingMessage }} </span>

                    <div class="pagercontrols medium-4 large-4 columns">
                        <span v-if="(meta.current_page != 1)" class="paginationbox active"><a
                                v-on:click="previous_page()"><i class="fa fa-angle-double-left"></i> Previous</a></span>
                        <span v-if="(page < meta.last_page)" class="paginationbox active"><a v-on:click="next_page()">Next <i
                                class="fa fa-angle-double-right"></i> </a></span>
                    </div>

                    <div class="pagerdetails medium-4 large-4 columns">
                        (Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} retailers)
                    </div>
                </div>

                <div v-if="loading" class="loading">
                    <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>

                <transition name="fade">
                <div v-if="(!loading)" class="retailerGrid">
                <div class="singleRetailer"
                     v-bind:class="{ child: ((retailer.retailer_group_id != 0) && (!triggerids.includes(retailer.id))) }"
                     v-for="retailer in processedRetailers"
                     v-bind:key="retailer.id" v-if="!retailer.hide" >
                    <div class="inner clearfix cf">
                        <div class="header_badge"></div>
                        <h4>{{retailer.name}}</h4>
                        <div v-if="(triggerids.includes(retailer.id) && !explodedids.includes(retailer.retailer_group_id))">
                            <strong>Multiple locations. </strong><br><a v-on:click="get_siblings(retailer.retailer_group_id)" class="showextraretailers blue-btn left">See all {{ retailer.num_locations }} Locations</a><br><br>
                        </div>
                        <div v-if="(triggerids.includes(retailer.id) && explodedids.includes(retailer.retailer_group_id))">
                            <strong></strong><br><a v-on:click="hide_siblings(retailer.retailer_group_id)" class="showextraretailers blue-btn left">Hide extra {{ retailer.num_locations }} Locations</a><br><br>
                        </div>
                        <div v-if="((retailer.is_online_only == 0) && (!triggerids.includes(retailer.id) || explodedids.includes(retailer.retailer_group_id)) && (retailer.street != ''))">
                            {{retailer.street}}<br>{{retailer.city}}, {{retailer.state}} {{retailer.postcode}}<br>{{retailer.country}}
                        </div>
                        <div v-if="(retailer.website)"><a
                            :href="retailer.website" target="_blank" class="weblink"
                            title="Visit this website in a new window">Website</a>
                        </div>
                    </div>
                </div>
                </div>
                </transition>

            </div>
        </div>
    </div>


</template>

<script>
    import ApiService from '../services/ApiService';

    export default {
        name: 'Retailers',
        components: {},
        props: {},
        data() {
            return {
                alphaselect: '',
                stateselect: '',
                typeselect: '',
                keyword: '',
                retailers: [],
                info: null,
                loading: true,
                errored: false,
                page: 1,
                meta: null,
                extra_locations: [],
                showingMessage: 'Showing all retailers',
                explodedids: [],
                triggerids:  [],
                retailergroupids : []
            }
        },
        created() {
            ApiService.getRetailers(this.page)
                .then(response => ( this.retailers = response.data ))
                .then(response => (this.meta = response.meta))
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        methods: {
            get_siblings(retailer_group_id) {

                ApiService.getRetailersInGroup(retailer_group_id)
                    .then(response => ( this.extra_locations = response.data ))
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => {
                        this.insert_extras(retailer_group_id);
                        if (!this.explodedids.includes(retailer_group_id)) this.explodedids.push(retailer_group_id);
                    });
            },
            get_retailers() {
                // console.log(this.alphaselect, this.typeselect, this.stateselect, this.keyword, this.page);
                this.loading = true;
                ApiService.getRetailers(this.page, this.alphaselect, this.typeselect, this.stateselect, this.keyword)
                    .then(response => ( this.retailers = response.data ))
                    .then(response => ( this.meta = response.meta ))
                    .catch(error => {
                        this.errored = true
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            get_retailers_by_alpha() {
                this.showingMessage = 'Showing retailers starting with ' + this.alphaselect;
                this.page = 1;
                this.stateselect = '';
                this.typeselect = '';
                this.keyword = '';
                this.condense = 1;
                this.get_retailers();
            },
            get_retailers_by_state() {
                let current_message = this.showingMessage;
                this.loading = true;
                if (this.stateselect == 'closest') {
                    this.showingMessage = 'Trying to find you...';
                    this.$getLocation({
                        timeout: 10000,
                        maximumAge: 300000 // five minutes.
                    })
                        .then(coordinates => {
                            console.log(coordinates);
                            ApiService.getClosestRetailers(coordinates)
                                .then(response => ( this.retailers = response.data ))
                                .then(response => ( this.meta = {
                                        'current_page': 1,
                                        'last_page': 1,
                                        'from': 1,
                                        'to': response.data.length,
                                        'total': response.data.length
                                } ))
                                .catch(error => {
                                    console.log(error);
                                    this.errored = true
                                })
                                .finally(() => {
                                    this.page = 1;
                                    this.alphaselect = '';
                                    this.typeselect = '';
                                    this.keyword = '';
                                    this.condense = 0;
                                    this.showingMessage = 'Showing locations closest to you.';
                                    this.loading = false;
                                    console.log(this);
                                });
                        }, reason => {
                            this.loading = false;
                            this.showingMessage = current_message;
                            alert("Sorry, we can't seem to locate you.")
                            this.stateselect = '';
                        });
                } else {
                    this.page = 1;
                    this.alphaselect = '';
                    this.typeselect = '';
                    this.keyword = '';
                    this.condense = 0;
                    this.showingMessage = 'Showing retailers in state/province ' + this.stateselect;
                    this.get_retailers();
                }
            },
            get_retailers_by_keyword() {
                if (!this.isZipOrCityState(this.keyword)) {
                    this.showingMessage = 'Showing retailers matching keyword "' + this.keyword + '"';
                } else {
                    this.showingMessage = 'Showing retailers within 10 miles of "' + this.keyword + '"';
                }
                this.page = 1;
                this.alphaselect = '';
                this.stateselect = '';
                this.typeselect = '';
                this.condense = 0;
                this.get_retailers();
            },
            get_retailers_by_type() {
                this.showingMessage = 'Showing retailers of selected type';
                this.page = 1;
                this.stateselect = '';
                this.alphaselect = '';
                this.keyword = '';
                this.condense = 0;
                this.get_retailers();
            },
            previous_page() {
                this.page--;
                this.get_retailers();
            },
            next_page() {
                this.page++;
                this.get_retailers();
            },
            insert_extras(retailer_group_id) {
                var triggerIndex = (this.retailers.data.findIndex( function(element) {
                    return element.retailer_group_id == retailer_group_id;
                }));
                this.retailers.data = this.retailers.data.slice(0, triggerIndex ).concat(this.extra_locations.data, this.retailers.data.slice(triggerIndex + 1));
                // this.retailers.data = this.retailers.data.map( function( element) {
                //    if (element.retailer_group_id == retailer_group_id) element.retailer_group_id = 0;
                //   return element;
                // });
            },
            hide_siblings(retailer_group_id) {
                this.explodedids = this.explodedids.filter( function( id) {
                    return (id != retailer_group_id);
                }, retailer_group_id);
                this.retailers.data = this.retailers.data.filter( function(retailer) {
                    return ((retailer.retailer_group_id == 0) || this.triggerids.includes(retailer.id)) ? true : false;
                }, this);
            },
            isZipOrCityState(value) {
                return (
                    /(^\d{5}([\-]\d{4})?$)/.test(value) ||
                    /(^[A-Za-z][0-9][A-Za-z]\s?[0-9][A-Za-z][0-9]$)/.test(value) ||
                    /(^[A-Za-z0-9 ]*,[A-Za-z0-9 ]*$)/.test(value)
                ) ? true : false;
            }
        },
        computed: {
            processedRetailers() {
                if ('undefined' != this.retailers) {
                    let retailers = this.retailers.data;
                    retailers.map( function(retailer) {
                       if (retailer.retailer_group_id != 0) {
                           if (!this.retailergroupids.includes(retailer.retailer_group_id)) {
                               this.retailergroupids.push(retailer.retailer_group_id);
                               this.triggerids.push(retailer.id);
                           }
                       }
                    }, this);
                    // console.log('here', brandProducts);
                    return retailers;
                } else {
                    return [];
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        font-size: 24px;
        font-weight: 500;
        margin: 40px 0 0;
    }

    h5 a {
        color: #555;
    }


    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .alpharetailerpager {
        text-align: center !important;
        padding: .5em 0;
    }

    /* https://css-tricks.com/snippets/css/css-grid-starter-layouts/ */
    .retailerGrid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 1em;
        margin: 0 auto;
        padding: 0;
    }

    .singleRetailer {
        align-items: normal;
        display: flex;
        width: auto !important;
    }
    .singleRetailer.child {
        background-color: #EFEFEF;
    }
    @media all and (max-width: 800px) {

    }

    #content .pagerdetails {
        line-height: 20px;
    }

</style>
